export default "__VITE_ASSET__7b7e5a56__"